export const SlideData = [
    {
      image:
        "https://img.shop.com/Image/homepage/shop-gbr-102789-holiday-hot-toys-banners-1600x300-img-min1669996056936.jpg"
    },
    {
      image:
        "https://img.shop.com/Image/homepage/shopping-pq2237-essentials-banner1556313062244.jpg"
    }
  ];
  // https://img.shop.com/Image/homepage/shopping-pq2237-essentials-banner1556313062244.jpg